import React, { useState } from 'react';
import { Plus, Minus, Music } from 'lucide-react';
import { FAQS } from '../../mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-28 bg-ink">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="reveal mb-12">
          <p className="eyebrow mb-4">Questions</p>
          <h2 className="font-display text-5xl md:text-6xl text-cream leading-[0.95]">Good to <span className="italic text-gold-grad">know.</span></h2>
        </div>
        <div className="divide-y divide-gold/10 border-y hairline">
          {FAQS.map((f, i) => (
            <div key={i} className="reveal">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 py-6 text-left group">
                <span className="font-display text-xl md:text-2xl text-cream group-hover:text-gold transition-colors">{f.q}</span>
                {open === i ? <Minus className="text-gold shrink-0" size={20} /> : <Plus className="text-cream/50 shrink-0" size={20} />}
              </button>
              <div className="overflow-hidden transition-all duration-500" style={{ maxHeight: open === i ? 200 : 0 }}>
                <p className="text-cream/65 leading-relaxed pb-6 pr-10">{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </section>
  );
}

function Footer() {
  return (
    <footer className="max-w-7xl mx-auto px-6 lg:px-10 mt-28 pt-12 border-t hairline">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-full border hairline"><Music size={16} className="text-gold" /></span>
          <span className="font-display text-lg text-cream">Brand <span className="italic text-gold-grad">Melody</span></span>
        </div>
        <p className="font-display italic text-cream/50 text-center">&ldquo;O sing unto the Lord a new song.&rdquo; &mdash; Psalm 96:1</p>
        <p className="text-xs text-cream/40">&copy; 2026 Heart N Soul Records</p>
      </div>
    </footer>
  );
}
